import {
  AVATAR_COlORS,
  API_ERROR_CODES,
  API_CODE,
  ERROR_STATUS_CODE,
  SPECIAL_CHARACTER_VALIDATION,
  CHAR_CODE,
  POST_TYPE,
  DateFormats
} from '../constants/enum';
import { navigate } from 'gatsby';
import moment from 'moment';
import axios from 'axios';
import { getImageData } from 'gatsby-plugin-image';

export const handleEnter = (event) => {
  if (event.key.toLowerCase() === 'enter') {
    const form = event.target.form;
    const index = [...form].indexOf(event.target);
    form.elements[index + 1].focus();
    event.preventDefault();
  }
  if (
    event.target.value.length === 0 &&
    event.key.toLowerCase() === 'backspace' &&
    (event.target.name === 'month' || event.target.name === 'year')
  ) {
    const form = event.target.form;
    const index = [...form].indexOf(event.target);
    form.elements[index - 1].focus();
    event.preventDefault();
  }
};

const colors = AVATAR_COlORS;
export function getAvatarBackgroundColor(text) {
  const charCodes = text
    ? text
        ?.split('')
        ?.map((char) => char.charCodeAt(0))
        ?.join('')
    : '-';
  return colors[parseInt(charCodes, 10) % colors.length];
}

export const MatchingModalApiErrorStatus = (getApiError) => {
  if (
    (getApiError?.status === API_ERROR_CODES.STATUS_422 &&
      getApiError?.data?.code !== ERROR_STATUS_CODE.ONB_1038 &&
      getApiError?.data?.code !== ERROR_STATUS_CODE.ONB_1008) ||
    getApiError?.status === API_ERROR_CODES.STATUS_412 ||
    getApiError?.status === API_ERROR_CODES.STATUS_403 ||
    getApiError?.status === API_ERROR_CODES?.STATUS_402
  ) {
    return true;
  } else {
    return false;
  }
};

export const MatchingInvoiceApiErrorStatus = (getApiError) => {
  if (getApiError?.status === API_ERROR_CODES.STATUS_400 || getApiError?.status === API_ERROR_CODES.STATUS_500) {
    return true;
  } else {
    return false;
  }
};
export const MatchingOopsApiErrorStatus = (error) => {
  if (
    error?.response?.status !== API_ERROR_CODES.STATUS_422 &&
    error?.response?.status !== API_ERROR_CODES.STATUS_412 &&
    error?.response?.status !== API_ERROR_CODES.STATUS_401 &&
    error?.response?.status !== API_ERROR_CODES.STATUS_402 &&
    error?.response?.status !== API_ERROR_CODES.STATUS_403
  ) {
    return true;
  } else {
    return false;
  }
};

export const Matching401ApiErrorStatus = (error) => {
  if (error?.response?.status === API_ERROR_CODES.STATUS_401) {
    return true;
  } else {
    return false;
  }
};

export const sendHubspotRequest = (final_data, hubspot_integration, isCompanyRegistrationWaitingFlow) => {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', hubspot_integration);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(final_data);
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == API_CODE.STATUS_200) {
      if (!isCompanyRegistrationWaitingFlow) {
        navigate('/thankyou');
      }
    } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_400) {
      console.log(xhr.responseText);
    } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_403) {
      console.log(xhr.responseText);
    } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_404) {
      console.log(xhr.responseText);
    }
  };
};

export const ConvertDateToDDMMMYYY = (date) => {
  return moment(date).format(DateFormats.DDMMMYYY);
};

export const redirectUserToLogin = (loginUrl = '/login') => {
  location.replace(loginUrl);
};
export async function fetchAppVersion() {
  try {
    let response = await axios.get('/app-version.html');
    let splittedAppVersion = response.data.toString().split('\n');
    let trimmedAppVersion = splittedAppVersion[0].trim();
    sessionStorage.setItem('app-version', trimmedAppVersion);
  } catch (error) {
    console.error(error);
  }
}

export const redirectToOopsPage = (error) => {
  navigate('/oops', {
    state: {
      message: error?.response?.data?.message,
      errorList: error?.response?.data?.items,
      apiErrorCode: error?.response?.data?.code,
      apiStatusCode: error?.response?.status
    }
  });
};

export const stringTruncate = (text, numberOfString) => {
  let finalString;
  if (text?.length > numberOfString) {
    finalString = text?.substring(0, numberOfString) + '...';
  } else {
    finalString = text;
  }
  return finalString;
};

export const relatedGuidesCustomUrl = (item) => {
  console.log(item, 'itemh', item?.document?.type);
  if (item?.document?.type === POST_TYPE?.BLOG) {
    if (item?.document?.data?.custom_url?.text)
      return `/blog/${item?.document?.data?.custom_url?.text}/${item?.document?.uid}`;
    if (item?.document?.data?.custom_url_without_blog?.text)
      return `/${item?.document?.data?.custom_url_without_blog?.text}/${item?.document?.uid}`;
    else return `/blog/${item?.document?.uid}`;
  }
  if (item?.document?.type === POST_TYPE?.ARTICLE) {
    if (item?.document?.data?.section_category?.document?.data?.custom_url?.text)
      return `/guides/${item?.document?.data?.silos_category?.document?.uid}/${item?.document?.data?.section_category?.document?.data.custom_url?.text}/${item?.document?.uid}`;
    else
      return `/guides/${item?.document?.data?.silos_category?.document?.uid}/${item?.document?.data?.section_category?.uid}/${item?.document?.uid}`;
  }
  if (item?.document?.type === POST_TYPE.SILOS_SECTION) {
    if (item?.document?.data?.custom_url?.text) {
      return `/guides/${item?.document?.data?.silos_category?.uid}/${item?.document?.data?.custom_url?.text}`;
    } else return `/guides/${item?.document?.data?.silos_category?.uid}/${item?.document?.uid}`;
  } else {
    return `/guides/${item?.document?.silos_category?.uid}/${item?.document?.uid}`;
  }
};

export const blogCustomUrl = (item) => {
  if (item?.data?.custom_url?.text) return `/blog/${item?.data?.custom_url?.text}/${item?.uid}`;
  if (item?.data?.custom_url_without_blog?.text) return `/${item?.data?.custom_url_without_blog?.text}/${item?.uid}`;
  else return `/blog/${item?.uid}`;
};
export const guidesCustomUrl = (item) => {
  if (!item?.data?.section_category?.uid) {
    if (item?.data?.custom_url?.text) {
      return `/guides/${item?.data?.silos_category?.uid}/${item?.data?.custom_url?.text}`;
    } else {
      return `/guides/${item?.data?.silos_category?.uid}/${item?.uid}`;
    }
  } else if (item?.data?.section_category?.document?.data?.custom_url?.text)
    return `/guides/${item?.data?.silos_category?.uid}/${item?.data?.section_category?.document?.data.custom_url?.text}/${item?.uid}`;
  else return `/guides/${item?.data?.silos_category?.uid}/${item?.data?.section_category?.uid}/${item?.uid}`;
};

export const navigateBlogCustomUrl = (categoryBlogs, index) => {
  if (categoryBlogs[index]?.data?.custom_url?.text)
    return `/blog/${categoryBlogs[index]?.data.custom_url?.text}/${categoryBlogs[index]?.uid}`;
  if (categoryBlogs[index]?.data?.custom_url_without_blog?.text)
    return `/${categoryBlogs[index]?.data.custom_url_without_blog?.text}/${categoryBlogs[index]?.uid}`;
  else return `/blog/${categoryBlogs[index]?.uid}`;
};

export const replaceSpaceAndSpecialCharacter = (text) => {
  return text
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_SPACE, '-')
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_NBSP, '')
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_COMMA, '')
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_NAMES, '')
    .toLocaleLowerCase();
};

export const defaultValidationMessage = (fieldName) => {
  return `Please provide a valid ${fieldName}`;
};

export function percentage(total, number) {
  return (number / total) * 100;
}

export const handleReDirectToStore = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};

export const handleKeyEnter = (event, performFunction) => {
  if (event?.keyCode === CHAR_CODE?.ENTER_KEY_CODE) {
    return performFunction();
  }
};

export const isBrowser = typeof window !== 'undefined';

export const numberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getLocalStorageValue = (key) => {
  const value = isBrowser && localStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
};

export function getExampleImageData({ image, ...props }) {
  return getImageData({
    baseUrl: image?.url,
    sourceWidth: image?.width,
    sourceHeight: image?.height,
    urlBuilder,
    pluginName: 'gatsby-plugin-sharp',
    formats: ['auto', 'webp'],
    ...props
  });
}

export function urlBuilder({ baseUrl }) {
  return baseUrl;
}
